import React from 'react';
import createSvgIcon from '../createSvgIcon';

export default createSvgIcon(
  <>
    <path
      fillRule="evenodd"
      d="m12.75 16.936 5.621-5.315a3 3 0 0 0-4.243-4.242 1.774 1.774 0 0 0-.087.11l-.012.015a6.67 6.67 0 0 1-.108.14L12.75 9.108l-1.172-1.464a7.07 7.07 0 0 1-.108-.14l-.011-.015a1.774 1.774 0 0 0-.088-.11 3 3 0 0 0-4.243 0c-1.17 1.17-1.17 3.071-.03 4.213l5.652 5.344Zm0-10.229A4.386 4.386 0 0 1 16.247 5c1.328 0 2.45.583 3.185 1.318a4.5 4.5 0 0 1 0 6.364L12.75 19l-6.682-6.318a4.5 4.5 0 0 1 0-6.364C6.81 5.576 8.006 5 9.248 5c1.244 0 2.68.576 3.502 1.707Z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M12.75 12c-.001 0-.001 0 0 0Z"
      clipRule="evenodd"
    />
  </>,
  'Heart',
  '4 4 17 16',
);
